export default class Menu {
  constructor(element) {
    this.element = element;
    this.events = {};
    this.state = {
      isOpen: false,
    };

    element && this.init();
  }

  init() {
    this.button = this.element.getElementsByClassName('c-menu__button')[0];
    this.buttonIcon = this.button.getElementsByClassName('c-menu__button-icon')[0];
    this.buttonText = this.button.getElementsByClassName('c-menu__button-text')[0];
    this.body = this.element.getElementsByClassName('c-menu__body')[0];
    this.focusableElements = Array.from(this.body.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]'));

    const handleClick = e => {
      e.preventDefault();
      this.toggle();
    };

    this.button.addEventListener('click', handleClick);
    this.events.clickButton = handleClick;

    const _checkDevice = device => {
      if (device === 'mobile' || device === 'tablet') {
        this.close();
        this.focusableElements.forEach(focusableElement => focusableElement.tabIndex = -1);
      } else {
        this.close();
        this.focusableElements.forEach(focusableElement => focusableElement.tabIndex = 0);
      }
    };

    document.addEventListener('changeMatchMedia', e => {
      const device = e.detail.device;
      _checkDevice(device);
    });

    _checkDevice(document.documentElement.dataset.device);
  };

  open() {
    this.button.classList.add('is-open');
    this.buttonIcon.classList.add('is-open');
    this.body.classList.add('is-open');
    this.focusableElements.forEach(focusableElement => focusableElement.tabIndex = 0);
    this.state.isOpen = true;

    return this;
  }

  close() {
    this.button.classList.remove('is-open');
    this.buttonIcon.classList.remove('is-open');
    this.body.classList.remove('is-open');
    this.focusableElements.forEach(focusableElement => focusableElement.tabIndex = -1);
    this.state.isOpen = false;

    return this;
  }

  toggle() {
    this.state.isOpen? this.close(): this.open();

    return this;
  }
};
